import * as yup from "yup";
import { useState } from "react";
import BaseForm from "../../../../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../../../../shared/components/input/FormInput";
import FormSelect from "../../../../../../../../../../shared/components/select/FormSelect";
import FormSwitch from "../../../../../../../../../../shared/components/switch/FormSwitch";

const EditNavbarItemsPermissionsForm = ({ onSubmitHandler, navbarItem }) => {
  const validationSchema = yup.object({});

  const defaultValues = {
    code: navbarItem?.code,
    label: navbarItem?.label,
    route: navbarItem?.route,
    status: navbarItem?.status,
    hasAccess: navbarItem?.hasAccess,
  };

  const [statuses, setStatuses] = useState([
    { label: "POC", value: "POC" },
    { label: "BETA", value: "BETA" },
    { label: "NEW", value: "NEW" },
    { label: "STABLE", value: "STABLE" },
    { label: "DEPRECATED", value: "DEPRECATED" },
  ]);

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      isCreationForm={false}
    >
      <FormInput name="code" label="Código" disabled />
      <FormInput name="label" label="Etiqueta i18n" disabled />
      <FormInput name="route" label="Ruta" disabled />
      <FormSelect name="status" label="Estado" options={statuses} />
      <FormSwitch name="hasAccess" label="Permitir acceso" />
    </BaseForm>
  );
};

export default EditNavbarItemsPermissionsForm;
